// Parent product component
if (!customElements.get('component-featured-products')) {
  customElements.define('component-featured-products', class FeaturedProducts extends HTMLElement {
    constructor() {
      super();
      // Listen for custom event sent from PDP on color change
      document.addEventListener('update-pdp-sections', this.renderSection);
      this.querySelectorAll('.js-featured-product').forEach(product => {
        product.addEventListener('click', () => {
          if (window.location.pathname.includes('/product')) {
            this.sendPDPGTMData(product.href, product.dataset.num);
          }
        })
      });
    }
    sendPDPGTMData(link, num) {
      window.sendGTMData && window.sendGTMData({
        event: 'pdp_product_recommendations',
        product_recommendations_number: num,
        product_recommendations_link: link
      });
    }
    async renderSection() {
      try {
        const sectionId = document.querySelector('component-featured-products').dataset.sectionId;
        let featuredProductsSection = await fetch(`${window.Shopify.routes.root}products/${event.detail.handle}?section_id=${sectionId}`);
        featuredProductsSection = await featuredProductsSection.text();
        if (featuredProductsSection) {
          document.querySelector('.js-component-featured-products').innerHTML = featuredProductsSection;
        }
      } catch (error) {
        console.error(error);
      }
    }
    disconnectedCallback() {
      document.removeEventListener('update-pdp-sections', this.renderSection, true);
    }
  });
}
